// src/Svgs/IconCheckCircle.tsx
import React from "react";
var IconCheckCircle = /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7667_208553)" }, /* @__PURE__ */ React.createElement("rect", { width: "16", height: "16", rx: "8", fill: "#20B26C" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.8986 5.588C12.1952 5.87716 12.2012 6.352 11.912 6.64858L7.52968 11.1433C7.24003 11.4403 6.76532 11.4491 6.46489 11.163L4.10776 8.9181C3.80781 8.63244 3.79623 8.15771 4.0819 7.85776C4.36756 7.55781 4.8423 7.54623 5.14224 7.8319L6.96797 9.57069L10.838 5.60143C11.1272 5.30485 11.602 5.29884 11.8986 5.588Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7667_208553" }, /* @__PURE__ */ React.createElement("rect", { width: "16", height: "16", rx: "8", fill: "white" })))
);
var IconCheckCircle_default = IconCheckCircle;
export {
  IconCheckCircle_default as default
};
